<div class="input-date">
  <mat-form-field
    floatLabel="always"
    appearance="outline"
    subscriptSizing="dynamic"
    [class.is-highlighted]="prefilled()"
    [hidden]="showMode()"
    (click)="openDatepicker(dp)"
  >
    @if (label()) {
      <mat-label class="input-date__label">
        @if (hint()) {
          <mat-icon
            class="input-date__hint"
            [matTooltip]="hint()"
          >
            info
          </mat-icon>
        }
        <div class="input-date__label-text">
          {{ label() }}
        </div>
        @if (isRequired && !showMode()) {
          <span class="input-required">*</span>
        }
      </mat-label>
    }
    <span class="mat-form-field__value">{{ value | date }}</span>
    <input
      class="mat-form-field__input"
      matInput
      autocomplete="off"
      readonly
      [matDatepicker]="dp"
      [formControl]="control()"
      [min]="min()"
      [max]="max()"
      [placeholder]="placeholder()"
      (dateChange)="onChange()"
    />
    @if (control().value && clearable() && control().enabled) {
      <mat-icon
        class="input-date__clear"
        (click)="clear(); $event.stopPropagation()"
      >
        clear
      </mat-icon>
    }
    <mat-datepicker-toggle
      class="primary"
      matSuffix
      [for]="dp"
      [disabled]="disabled() || control().disabled"
    />
    <mat-datepicker
      #dp
      panelClass="datepicker"
      [disabled]="disabled() || control().disabled"
      [startAt]="startAt()"
      [startView]="startView()"
      [id]="id()"
    />
  </mat-form-field>
  <procure-show-field
    [hidden]="!showMode()"
    [label]="label()"
    [hint]="hint()"
  >
    {{ (value | date) || "-" }}
  </procure-show-field>
</div>
@if (prefilled()) {
  <div class="undo-link">
    <a
      class="text-link"
      target="_blank"
      rel="noopener noreferrer"
      (click)="onUndo()"
    >
      Undo
    </a>
  </div>
}
